<template>
	<div class="toggle-wrapper">
		<div :class="['button', 'toggle-item', { disabled: isDisabled }, localValue == localValues[0] ? 'toggle-action' : 'toggle-grey']" @click="doToggle(localValues[0])" tabindex="0">{{ localLabels[0] }}</div>
		<div :class="['button', 'toggle-item', { disabled: isDisabled }, localValue == localValues[1] ? 'toggle-action' : 'toggle-grey']" @click="doToggle(localValues[1])" tabindex="0">{{ localLabels[1] }}</div>
		<div v-if="tertiary || rondo" :class="['button', 'toggle-item', { disabled: isDisabled }, localValue == localValues[2] ? 'toggle-action' : 'toggle-grey']" @click="doToggle(localValues[2])" tabindex="0">{{ localLabels[2] }}</div>
		<div v-if="rondo" :class="['button', 'toggle-item', { disabled: isDisabled }, localValue == localValues[3] ? 'toggle-action' : 'toggle-grey']" @click="doToggle(localValues[3])" tabindex="0">{{ localLabels[3] }}</div>
	</div>
</template>
<script>
export default {
	name: 'binary-toggle',
	props: {
		value: {
			type: [Number, String, Boolean],
			required: false
		},
		labels: {
			type: [String],
			required: false,
		},
		values: {
			type: [String],
			required: false,
		},
		default: {
			type: [Boolean, String],
			required: false,
		},
		tertiary: {
			type: [Boolean, String],
			required: false,
			default: false
		},
		rondo: {
			type: [Boolean, String],
			required: false,
			default: false
		},
		reverse: {
			type: [Boolean, String],
			required: false,
			default: false
		},
		disabled: {
			type: [Boolean, String, Number],
			required: false,
			default: false
		}
	},
	data() {
		return {
			localValue: '',
			localLabels: [],
			localValues: []
		}
	},
	computed: {
		isDisabled() {
			return this.disabled != 0 && this.disabled != ''
		}
	},
	created() {
		if (this.labels && this.labels.search(',') > -1) {
			this.localLabels = this.labels.split(',')
		} else if (this.tertiary) {
			this.localLabels = ['Yes', 'No', 'Unknown']
			this.localValues = ['1', '', 'U']
		} else {
			if (this.reverse) {
				this.localLabels = ['No', 'Yes']
				this.localValues = ['', '1']
			} else {
				this.localLabels = ['Yes', 'No']
				this.localValues = ['1', '']
			}
		}
		if (this.values && this.values.search(',') > -1) {
			this.localValues = this.values.split(',')
		} else {
			this.localValues = this.localLabels
		}
		if (this.default && !this.value) {
			this.localValue = this.default
		} else {
			if (this.value === null) {
				this.localValue = ''
			} else {
				this.localValue = this.value
			}
		}
	},
	methods: {
		doToggle(which) {
			if (this.disabled) { return }
			if (this.localValue == which) {
				this.localValue = ''
			} else {
				this.localValue = which
			}
			this.$emit('input', this.localValue)
		}
	}
}
</script>

<style lang="scss" scoped>
.toggle-wrapper {
	.toggle-item {
		display: inline-block;
		min-width: 4em;
		padding: 0.25em 0.5em;
		text-align: center;
		margin: 0 0.25em;
		border-radius: 4px;
		border: 2px solid #c3c3c3;
	}
	.toggle-action {
		color: #ffffff;
  		background: #4a4a4a;
		border: 2px solid #4BBDAD;
	}
	.toggle-grey {
		color: #8b8b8b;
  		background: #ffffff;
	}
}
</style>
